module.exports = __webpack_public_path__ + "img/ch71.4c786ceb.jpg";